import { useQuery } from "@tanstack/react-query";
import { useField } from "formik";
import React from "react";

import { getHubspotLeadSources } from "api/hubspot";
import { hubspotKeys } from "api/hubspot/queries";
import FormikAutocomplete from "components/forms/FormikAutocomplete";

const HubspotLeadSourceField = () => {
  const [field] = useField<string | null>("leadSource");
  const { data, isLoading, isError } = useQuery(
    hubspotKeys.leadSources(),
    async () => (await getHubspotLeadSources()).data,
    { staleTime: 5 * 60 * 1000, refetchInterval: 5 * 60 * 1000, retry: false },
  );
  const options = data?.data ?? [];
  const legacy =
    !!field.value && !options.some((option) => option.value === field.value);
  // Keep a legacy selection visible without offering it for other customers.
  const displayedOptions = legacy
    ? [...options, { label: field.value!, value: field.value! }]
    : options;
  const unavailable = isError || data?.stale;

  return (
    <FormikAutocomplete
      label="Lead Source"
      name="leadSource"
      options={displayedOptions}
      loading={isLoading}
      disabled={!options.length}
      getOptionDisabled={(option) =>
        !options.some((active) => active.value === option.value)
      }
      helperText={
        unavailable
          ? "HubSpot choices are temporarily unavailable. Existing values are unchanged."
          : isLoading
            ? "Loading lead sources…"
            : !options.length
              ? "No lead source choices are currently available. Existing values are unchanged."
              : legacy
                ? "Current value is retained. Choose a HubSpot source only if you want to change it."
                : undefined
      }
    />
  );
};

export default HubspotLeadSourceField;
